export default __webpack_public_path__ + "static/media/servicos_desktop.9c753e78.png";